
        require('./index.scss');
        'use strict';

var $ = window.$;
var $log = require('model/service/log.js');
var $mod = $('.module-loupan-header');
var _module = {
    init: function init() {
        $log.loupan({
            pid: parseInt($mod.attr('data-proj_id')),
            projName: $mod.attr('data-proj_name'),
            cityId: parseInt($mod.attr('data-city_id')),
            cityName: $mod.attr('data-city_name'),
            sign: $mod.attr('data-sign')
        });
    }
};

_module.init();

var icon = $('.wechat-group .wechat-group-icon');
var qrcode = $('.wechat-group .wechat-group-qrcode-wrapper');

if (icon && qrcode) {
    // $(qrcode).hide();
    $(icon).hover(function () {
        $(qrcode).show();
    }, function () {
        $(qrcode).hide();
    });
};
    


// WEBPACK FOOTER //
// ./src/module/loupan-common/header-new/index.js